import React, { useState, useEffect } from 'react';
import { Button, styled } from '@mui/material';
import {NavLink} from 'react-router-dom';

const Root = styled('div')(({ theme }) => ({
  padding: theme.spacing(3)
}));

const Content = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2)
}));

export const ReportList = () => {
  return (
    <Root>
      <Content>
        <h2>All reports</h2>
        <Button color="secondary" variant="contained" to="/reports/client-integrations" component={NavLink}>Client integrations</Button>
      </Content>
    </Root>
  );
};

